import React from "react";
import { useApp } from "@/context/AppContext";

const COLORS = {
  pending: "bg-secondary text-secondary-foreground border-secondary",
  approved: "bg-accent text-accent-foreground border-accent",
  changes_requested: "bg-primary text-primary-foreground border-primary",
  rejected: "bg-destructive text-destructive-foreground border-destructive",
  unpublished: "bg-muted text-foreground", draft: "bg-muted text-foreground",
};
const KEYS = { pending: "awaitingReview", approved: "approvedLive", changes_requested: "changesRequested", rejected: "rejected", unpublished: "unpublished", draft: "draft" };

export default function StatusBadge({ status, className = "" }) {
  const { t } = useApp();
  return <span className={`eyebrow !text-[10px] px-2 py-1 border whitespace-nowrap ${COLORS[status] || "border-foreground"} ${className}`} data-testid={`status-${status}`}>{t(KEYS[status] || status)}</span>;
}

export function waitingLabel(h) {
  if (h == null) return "";
  if (h < 1) return "<1h"; if (h < 48) return `${Math.round(h)}h`; return `${Math.round(h / 24)}d`;
}
